import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type GetStudioItemOperation = Operation<'GetHeySynclyStudioItem'>;

export type GetStudioItemParams =
  GetStudioItemOperation['parameters']['path'];

export type GetStudioItemResponse = Schema<'HeySynclyStudioItem'>;

export const getStudioItem = ({
  item_id,
}: GetStudioItemParams): Promise<GetStudioItemResponse> =>
  v1ApiClient
    .get(`/hey-syncly/studio/items/${item_id}`)
    .then((response) => response.data);
